{
  "cms.upload.button": "Lataa",
  "cms.upload.buttonReplace": "Vaihda tiedosto",
  "cms.upload.error.imageTooLarge": "Kuva on liian suuri (max 10 MB).",
  "cms.upload.error.svgRejected": "SVG-kuvia ei voi ladata.",
  "cms.upload.error.uploadFailed": "Lataus epäonnistui. Yritä uudelleen.",
  "cms.upload.error.videoTooLarge": "Video on liian suuri (max 200 MB).",
  "cms.upload.error.wrongType.both": "Tiedoston tulee olla kuva tai video.",
  "cms.upload.error.wrongType.image": "Tiedoston tulee olla kuva.",
  "cms.upload.error.wrongType.video": "Tiedoston tulee olla video.",
  "cms.upload.helper.both": "Lataa kuva (max 10 MB) tai video (max 200 MB).",
  "cms.upload.helper.image": "Lataa kuva (max 10 MB).",
  "cms.upload.helper.video": "Lataa video (max 200 MB).",
  "cms.upload.loading": "Ladataan…",
  "cms.upload.remove": "Poista",
  "cms.upload.videoUrl.helper": "Liitä videolinkki (https://) tai lataa videotiedosto (max 200 MB).",
  "cms.upload.crop.trigger": "Rajaa kuvaa",
  "cms.upload.crop.title": "Rajaa kuva",
  "cms.upload.crop.description": "Valitse kuvasta rajattava alue ja tallenna rajaus.",
  "cms.upload.crop.aspect.label": "Kuvasuhde",
  "cms.upload.crop.aspect.free": "Vapaa",
  "cms.upload.crop.aspect.square": "1:1 (neliö)",
  "cms.upload.crop.imageAlt": "Rajattava kuva",
  "cms.upload.crop.save": "Tallenna rajaus",
  "cms.upload.crop.saving": "Tallennetaan…",
  "cms.upload.crop.cancel": "Peruuta",
  "cms.upload.crop.noSelection": "Valitse rajaus ensin.",
  "cms.upload.crop.error": "Rajaus epäonnistui. Yritä uudelleen.",
  "cms.upload.alt.label": "Vaihtoehtoinen teksti (alt)",
  "cms.upload.alt.placeholder": "Kuvaile kuvaa lyhyesti"
}
